let ershou = [
	//1
	{
		accessories: null,
		address: "天津市市辖区和平区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-23 14:12:53",
		detailAddress: "耳机俄罗斯就是的",
		displayTime: 500,
		district: "和平区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "116.78637999741771,39.035461896189847",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/a83e8c29b15e4aee98278645388570d4.jpg",
		price: 50,
		produceTime: 2018,
		province: "天津市",
		remark: "啊了头诺头诺头居然特头诺",
		secondBrandId: 8,
		secondBrandName: "徐工",
		secondMachineId: 23,
		secondModelId: 5,
		secondModelName: "XR150",
		secondTypeId: 5,
		secondTypeName: "旋挖钻机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: null,
		stewardName: null,
		stewardStatus: 1,
		stewardTel: null,
		title: "徐工150天津和平价格面议",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20213724",
		updateTime: "2021-07-23 14:13:32",
		userId: 4434,
		username: "山上吹冷风",
	},
	//2
	{
		accessories: null,
		address: "重庆市市辖区璧山区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-07 17:52:32",
		detailAddress: "璧山",
		displayTime: 15741,
		district: "璧山区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.23286910476083,29.596965590548068",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/64b0e04fb39a471ba0663c391471ca78.jpg",
		price: 105,
		produceTime: 2017,
		province: "重庆市",
		remark: "",
		secondBrandId: 8,
		secondBrandName: "徐工",
		secondMachineId: 14,
		secondModelId: 31,
		secondModelName: "XR360",
		secondTypeId: 5,
		secondTypeName: "旋挖钻机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4244,
		stewardName: "周老师",
		stewardStatus: 0,
		stewardTel: "15310162879",
		title: "徐工360重庆璧山价格面议 ",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20214446",
		updateTime: "2021-07-07 17:54:59",
		userId: 4434,
		username: "山上吹冷风",
	},
	//3
	{
		accessories: null,
		address: "重庆市市辖区渝北区",
		attachmentPictures: "http://image.hudiejx.com/secondMachineWanted/20210709/2da8ee7e552b46f7814343224b6463c0.jpeg",
		city: "市辖区",
		createTime: "2021-07-07 17:48:36",
		detailAddress: "空港",
		displayTime: 3500,
		district: "渝北区",
		frameNumber: "Jjhh4528554",
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.6375590606026,29.723927343006627",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/11e2f6ddec9f45ea85d552871334a18c.jpg",
		price: 80,
		produceTime: 2017,
		province: "重庆市",
		remark: "",
		secondBrandId: 8,
		secondBrandName: "徐工",
		secondMachineId: 13,
		secondModelId: 29,
		secondModelName: "XR280D",
		secondTypeId: 5,
		secondTypeName: "旋挖钻机",
		status: 3,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4225,
		stewardName: "周老师",
		stewardStatus: 0,
		stewardTel: "18580701460",
		title: "徐工280D重庆空港价格面议",
		transactionInquiryId: 15,
		transactionUserId: 4225,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20215672",
		updateTime: "2021-07-09 11:37:56",
		userId: 4434,
		username: "山上吹冷风",
	},
	//4
	{
		accessories: null,
		address: "重庆市市辖区九龙坡区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-07 09:03:53",
		detailAddress: "九龙坡地区",
		displayTime: 4371,
		district: "九龙坡区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.55264727128329,29.496761779923238",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/75ab5f67280749d69487240ce17c2eaf.jpg",
		price: 13,
		produceTime: 2014,
		province: "重庆市",
		remark: "",
		secondBrandId: 22,
		secondBrandName: "柳工",
		secondMachineId: 12,
		secondModelId: 21,
		secondModelName: "面议咨询型号",
		secondTypeId: 8,
		secondTypeName: "装载机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4434,
		stewardName: "赵先生",
		stewardStatus: 0,
		stewardTel: "17353226271",
		title: "14年柳工50cn长臂",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20219640",
		updateTime: "2021-07-07 09:06:43",
		userId: 4225,
		username: "花式探员",
	},
	//5
	{
		accessories: null,
		address: "重庆市市辖区九龙坡区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-07 09:03:53",
		detailAddress: "九龙坡地区",
		displayTime: 3357,
		district: "南岸区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.55264727128329,29.496761779923238",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/c576f07df2e942a0a2a40f711076fd68.jpg",
		price: 13,
		produceTime: 2014,
		province: "重庆市",
		remark: "",
		secondBrandId: 22,
		secondBrandName: "柳工",
		secondMachineId: 12,
		secondModelId: 21,
		secondModelName: "面议咨询型号",
		secondTypeId: 8,
		secondTypeName: "装载机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4434,
		stewardName: "赵先生",
		stewardStatus: 0,
		stewardTel: "17353226271",
		title: "徐工XR180D旋转挖机",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20219640",
		updateTime: "2021-07-07 09:06:43",
		userId: 4225,
		username: "花式探员",
	},
	//6
	{
		accessories: null,
		address: "重庆市市辖区九龙坡区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-07 09:03:53",
		detailAddress: "九龙坡地区",
		displayTime: 2668,
		district: "沙坪坝区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.55264727128329,29.496761779923238",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/790acb5d3b1b4bf99dac41a2f674b70f.jpg",
		price: 13,
		produceTime: 2014,
		province: "重庆市",
		remark: "",
		secondBrandId: 22,
		secondBrandName: "柳工",
		secondMachineId: 12,
		secondModelId: 21,
		secondModelName: "面议咨询型号",
		secondTypeId: 8,
		secondTypeName: "装载机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4434,
		stewardName: "赵先生",
		stewardStatus: 0,
		stewardTel: "17353226271",
		title: "徐工XR160E",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20219640",
		updateTime: "2021-07-07 09:06:43",
		userId: 4225,
		username: "花式探员",
	},
	//7
	{
		accessories: null,
		address: "重庆市市辖区九龙坡区",
		attachmentPictures: null,
		city: "市辖区",
		createTime: "2021-07-07 09:03:53",
		detailAddress: "九龙坡地区",
		displayTime: 3379,
		district: "九龙坡区",
		frameNumber: null,
		isCollected: null,
		isInquiried: null,
		isOwn: null,
		location: "106.55264727128329,29.496761779923238",
		payWay: "协商付款",
		pictures: "http://image.hudiejx.com/secondMachine/20210707/bfccea2a5370403f8889858aaf8d03c4.jpg",
		price: 13,
		produceTime: 2014,
		province: "重庆市",
		remark: "",
		secondBrandId: 22,
		secondBrandName: "柳工",
		secondMachineId: 12,
		secondModelId: 21,
		secondModelName: "面议咨询型号",
		secondTypeId: 8,
		secondTypeName: "装载机",
		status: 1,
		statusName: null,
		stewardAvatar: null,
		stewardId: 4434,
		stewardName: "赵先生",
		stewardStatus: 0,
		stewardTel: "17353226271",
		title: "徐工XR150",
		transactionInquiryId: null,
		transactionUserId: null,
		transactionUserName: null,
		transactionUserTel: null,
		uniqueId: "ES20219640",
		updateTime: "2021-07-07 09:06:43",
		userId: 4225,
		username: "花式探员",
	},
]

module.exports = {
	ershou: ershou
}